import * as angular from 'angular';
import * as _ from 'lodash';

import { RequestService } from './request.service';
import { StoreService, StoreActionsService } from '.';

export const serviceModule = 'wt-services-module';

const angularModule = angular.module(serviceModule, [])
    .service(RequestService.serviceId, RequestService);

import * as ViewModelServices from './vm/index';
import * as DataServices from './data/index';
import * as GeneralServices from './general/index';
import * as HelpersServices from './helpers/index';
import * as StatesServices from './states/index';
import * as WidgetsServices from './widgets/index';
import { MsalAuthenticationProvider } from './msalAuthentication.provider';

function registerServices(serviceModule: any) {
    for (const key of Object.keys(serviceModule)) {
        angularModule.service(serviceModule[key].serviceId, serviceModule[key]);
    }
}

registerServices(ViewModelServices);
registerServices(DataServices);
registerServices(GeneralServices);
registerServices(HelpersServices);
registerServices(StatesServices);
registerServices(WidgetsServices);

angularModule.service(StoreService.serviceId, StoreService)
.service(StoreActionsService.serviceId, StoreActionsService)
.provider(MsalAuthenticationProvider.serviceId, MsalAuthenticationProvider);